/**
 * Meta – sets document title and description for preview pages.
 * Used by website-preview profile pages.
 */

import { useEffect } from "react";

export interface MetaProps {
  title?: string;
  description?: string;
}

export function Meta({ title, description }: MetaProps) {
  useEffect(() => {
    if (title) document.title = title;
    return () => {
      document.title = "Cockpit";
    };
  }, [title]);

  useEffect(() => {
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("name", "description");
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", description);
    }
  }, [description]);

  return null;
}
